<template>
    <C1Button
        type="button"
        variant="neutral"
        @click.stop.prevent="applyNow()"
        :size="size"
        class="af-btn-quick-apply afu-truncate"
    >
        <slot />
    </C1Button>
</template>

<script>
    import ApplyJobMixin from '@/apps/jobview/001/components/Actions/ApplyJobMixin.vue';

    export default {
        name: 'QuickApplyJob',
        mixins: [ApplyJobMixin],
        props: {
            job: {
                type: Object,
                required: true,
            },
            size: {
                type: String,
                default: 'md',
                validator: value => ['sm', 'lg', 'md', 'xl'].includes(value),
            },
        },
        computed: {
            $_job() {
                return this.job;
            },
        },

    };
</script>
